import SearchProd from './SearchProd';

const ACTION = {
  ...SearchProd.ACTION,
};

const ACTION_TYPES = {
  ...SearchProd.ACTION_TYPES,
};

const Search = {
  ACTION,
  ACTION_TYPES
}

export default Search;